<mat-card>
  <mat-card-header class="center card-header">
    <mat-card-title i18n="Stats|School Enrol stats title@@stats-school-enrol-stats-title">
      School Enrollments
    </mat-card-title>
    <mat-card-subtitle class="center-align">
      <mat-slide-toggle class="school-mode-selector"
                        color="primary"
                        (toggleChange)="schoolModeChanged()"
                        [disabled]="schoolStats && !schoolStats.length"
                        [checked]="showAllSchools">
        <ng-container *ngIf="showAllSchools"
                      i18n="Stats|School Enrol stats all schools toggle title@@stats-school-enrol-stats-all-schools-toggle-title">
          Show all schools data
        </ng-container>
        <ng-container *ngIf="!showAllSchools"
                      i18n="Stats|School Enrol stats registered schools toggle title@@stats-school-enrol-stats-registered-schools-toggle-title">
          Show enrolled schools data
        </ng-container>
      </mat-slide-toggle>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="stats-content">
    <mat-spinner *ngIf="!schoolStats" [diameter]="30" class="center-middle" color="primary"></mat-spinner>

    <app-no-content *ngIf="schoolStats && !schoolStats.length"
                    [compact]="true"
                    title="School enrollment stats data is missing for the selected contest"
                    i18n-title="Stats|School Enrol stats missing title@@stats-school-enrol-stats-missing-title"
                    details="Stats will be added when students start to enrol for the contest"
                    i18n-details="Stats|School Enrol stats missing details@@stats-school-enrol-stats-missing-details"></app-no-content>

    <div *ngIf="schoolStats && schoolStats.length > 0">
      <table mat-table multiTemplateDataRows
             [dataSource]="schoolStats"
             class="mat-elevation-z4 full-width">

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="row-action text-disabled-color">
            <mat-icon (click)="seeSchoolDetails(element.schoolId); $event.stopPropagation();">sticky_note_2</mat-icon>
          </td>
        </ng-container>

        <!-- School Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef
              i18n="Stats|School Enrol stats school column name@@stats-school-enrol-stats-school-column-name">School
          </th>
          <td mat-cell *matCellDef="let element" class="word-wrap">{{element.schoolName}}</td>
        </ng-container>

        <!-- Successful status Column -->
        <ng-container matColumnDef="successful">
          <th mat-header-cell *matHeaderCellDef
              class="content-header center">{{localizeStatus(statuses.successful)}}</th>
          <td mat-cell *matCellDef="let element" class="data-content">{{element.status_successful}}</td>
        </ng-container>

        <!-- Pending status Column -->
        <ng-container matColumnDef="pending">
          <th mat-header-cell *matHeaderCellDef class="content-header center">{{localizeStatus(statuses.pending)}}</th>
          <td mat-cell *matCellDef="let element" class="data-content">{{element.status_pending}}</td>
        </ng-container>

        <!-- Scheduled status Column -->
        <ng-container matColumnDef="scheduled">
          <th mat-header-cell *matHeaderCellDef
              class="content-header center">{{localizeStatus(statuses.scheduled)}}</th>
          <td mat-cell *matCellDef="let element" class="data-content">{{element.status_scheduled}}</td>
        </ng-container>

        <!-- Failed status Column -->
        <ng-container matColumnDef="failed">
          <th mat-header-cell *matHeaderCellDef class="content-header center">{{localizeStatus(statuses.failed)}}</th>
          <td mat-cell *matCellDef="let element" class="data-content">{{element.status_failed}}</td>
        </ng-container>

        <!-- Invitation not Accepted status Column -->
        <ng-container matColumnDef="invitation_not_accepted">
          <th mat-header-cell *matHeaderCellDef
              class="content-header center">{{localizeUserStatus('FORCE_CHANGE_PASSWORD')}}</th>
          <td mat-cell *matCellDef="let element" class="data-content">{{element.user_status_unconfirmed}}</td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
            <div *ngIf="element.type" class="school-element-detail"
                 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <div class="school-element-diagram">
                <bar-chart *ngIf="largeScreenView; else smallScreen" title="Enrollment by Grade"
                           i18n-title="Stats|School Enrol stats grade chart title@@stats-school-enrol-stats-grade-chart-title"
                           noContentTitle="Grade enrollment stats data is missing for the selected contest"
                           i18n-noContentTitle="Stats|Grade Enrol stats missing title@@stats-grade-enrol-stats-missing-title"
                           noContentDetails="Stats will be added when students start to enrol for the contest"
                           i18n-noContentDetails="Stats|Grade Enrol stats missing details@@stats-grade-enrol-stats-missing-details"
                           [inlineTitle]="true"
                           [height]="150"
                           [labels]="gradeStatsLabels"
                           [data]="enrolGradeChartData(element)"></bar-chart>
                <ng-template #smallScreen>
                  <doughnut-chart title="Enrollment by Grade"
                                  i18n-title="Stats|School Enrol stats grade chart title@@stats-school-enrol-stats-grade-chart-title"
                                  noContentTitle="Grade enrollment stats data is missing for the selected contest"
                                  i18n-noContentTitle="Stats|Grade Enrol stats missing title@@stats-grade-enrol-stats-missing-title"
                                  noContentDetails="Stats will be added when students start to enrol for the contest"
                                  i18n-noContentDetails="Stats|Grade Enrol stats missing details@@stats-grade-enrol-stats-missing-details"
                                  [inlineTitle]="true"
                                  [height]="150"
                                  [labels]="gradeStatsLabels"
                                  [data]="enrolGradeChartData(element)"></doughnut-chart>
                </ng-template>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
            class="school-element-row"
            [class.has-data]="showAllSchools && element.type"
            [class.school-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"></tr>
        <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="school-detail-row"></tr>
      </table>
    </div>
  </mat-card-content>

  <mat-card-footer *ngIf="pageToken" class="center-align">
    <app-link class="load-more-link"
              icon="arrow_downward"
              label="load more"
              i18n-label="Students List|Load More link label@@students-list-load-more-link-label"
              (click)="loadNextPage.emit(pageToken)"></app-link>
  </mat-card-footer>
</mat-card>
